import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getGraphics = createAsyncThunk("graphics/get", async (payload) => {
  try {
    const response = await magnifiAPI.getGraphics(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteGraphics = createAsyncThunk("graphics/delete", async (payload) => {
  try {
    const response = await magnifiAPI.deleteGraphics(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const uploadGraphics = createAsyncThunk("graphics/get", async (payload) => {
  try {
    const response = await magnifiAPI.uploadGraphics(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getGraphicsById = createAsyncThunk("graphics/getById", async (payload) => {
  try {
    const response = await magnifiAPI.getGraphicsById(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
